import { RAI } from 'types/Concessionnaire';

export enum UserRole {
  MANAGER = 'MANAGER',
  TECHNICIAN = 'TECHNICIAN',
}

export enum AccessType {
  CLIENT = 'CLIENT',
  SIMULATEUR = 'SIMULATEUR',
  CONCESSIONNAIRE = 'CONCESSIONNAIRE',
}

export interface User {
  id: number;
  username: string;
  email: string;
  confirmed: boolean;
  blocked: boolean;
  firstname: string;
  lastname: string;
  numero_contrat: string;
  raison_sociale_entreprise: string;
  resetPasswordTokenCreatedAt: string | null;
  createdAt: Date;
  updatedAt: Date;
  accessType: AccessType;
  role: UserRole;
  impersonated?: boolean;
  createdBy?: User;
  updatedBy?: User;

  // Utilisé pour les concessionnaires
  contractRAI?: RAI;

  logoUrl?: string | null; // URL du logo du Account de l'utilisateur
}

export interface UserOwner {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}
